import { useState, useEffect } from 'preact/hooks';
import { AnchorCheckbox, AnchorIcon, AnchorProductIllustration } from '@tryg/react-ui-library'
import { updateInsuranceAction } from '../../actions/UserData'
import { CombinedInsuranceAdditional } from './CombinedInsuranceAdditional';
import Text from '../Global/Text';
import PropTypes from 'prop-types';
import { getMaxDecimalPlaces } from '../../utilities/combined-common'

export const CombinedInsuranceSelector = (
  {
    components, 
    dispatch, 
    initialCheckedState,
    getExpandState,
    getPrice,
    accordion,
    showAdditionalCoverage,
    useBasketList,
    values,
    setValues,
    basketList,
    userData
  }) => {

  const [checked, setChecked] = useState(initialCheckedState)
  const [expand, setExpand] = useState(getExpandState(initialCheckedState))
  const [addCov, setAddCov] = useState(initialCheckedState)
  
  useEffect(() => {
    // setting expand each time checked state changes due to an overriding problem
    setExpand(getExpandState(checked))
    setAddCov(checked)
  }, [checked])

  // initally dispatching events
  useEffect(() => {
    // for default checked items if present
    let defaultCheckedItems=[];
    for (const [key, value] of Object.entries(initialCheckedState)) {
      if(value) {
        defaultCheckedItems = components.filter((item) => item.name === key)
      }
    }
    defaultCheckedItems.forEach((item) => {
      const id = item.id
      const name = item.name
      dispatchInsuranceSelection(id, name, true)
    })
  },[])

  // checking the insurance if any additional coverage has been selected
  useEffect(() => {
    for (const [key, value] of Object.entries(addCov)) {
      if(value) {
        if(!checked[key]) {
          setChecked((prevChecked) => ({
            ...prevChecked,
            [key]: value
          }));
          components.forEach((item) => {
            item.name === key && dispatchInsuranceSelection(item.id, item.name, value)
          })
        }
      }
   }
  },[addCov])

  const productList = Object.keys(checked).filter((key) => checked[key])
  const displayComponents = (!useBasketList || basketList.length === 0 || !showAdditionalCoverage) 
                            ? components 
                            : components.filter(item => productList.includes(item.name))

  const getIconName = (item) => {
    if(expand[item]) {
      return 'chevron-up'
    }
    return 'chevron-down'
  }

  const dispatchInsuranceSelection = (id, name, check) => {
    values[id] = !checked[name];
    check ? (!productList.includes(name) && productList.push(name)) : productList.splice(productList.indexOf(name), 1)
    const tprice = userData.totalPrice;
    let newTotalCost;
    let newTotalPackagePrice = check ? 
                                (userData[`totalPrice-${name}`] ? 
                                  parseFloat((userData[`totalPrice-${name}`] + getPrice(name)).toFixed(getMaxDecimalPlaces(userData[`totalPrice-${name}`],getPrice(name))))
                                                                : getPrice(name))
                                : (userData[`totalPrice-${name}`] ? 
                                  parseFloat((userData[`totalPrice-${name}`] - getPrice(name)).toFixed(getMaxDecimalPlaces(userData[`totalPrice-${name}`],getPrice(name)))) 
                                                                : 0);
    const additionalCoverageKey = `additionalCoverage-${name}`;
    let currentState = userData[additionalCoverageKey] || [];
    let totalPackagePrice = userData[`totalPrice-${name}`] ? userData[`totalPrice-${name}`]
                                                                                : 0;


    if (check) {
      newTotalCost = tprice + getPrice(name)
    }
    if (!check) {
      const maxDecimals = getMaxDecimalPlaces(tprice, totalPackagePrice)
      newTotalCost = parseFloat((tprice - totalPackagePrice).toFixed(maxDecimals));
      newTotalPackagePrice = 0;
      currentState = [];
    }

    setValues({
      ...values,
      initialCost: newTotalCost,
      totalPrice: newTotalCost
    });
    dispatch(updateInsuranceAction({
      [id] : check,
      productList: productList,
      basketList: productList,
      initialCost: newTotalCost,
      totalPrice: newTotalCost,
      [`totalPrice-${name}`]: newTotalPackagePrice,
      [`additionalCoverage-${name}`]: currentState
    }));
  }

  const handleToggle = (event) => {

    setChecked((prevChecked) => ({
      ...prevChecked,
      [event.detail.value.name]: event.detail.checked
    }));

    const id = event.detail.value.id
    const name = event.detail.value.name
    const check = event.detail.checked

    dispatchInsuranceSelection(id, name, check)
  }

  const handleAccordionExpansion = (item) => {
    setExpand((prevExpand) => ({
      ...prevExpand,
      [item]: !prevExpand[item]
    }))
  }

  return (
      <div>
        {displayComponents.map((item, index) => {
          return (
            <div key={item.name} className='insurance_selector_main'>
              <div className='insurance_selector_head_content' onClick={accordion ? ()=>handleAccordionExpansion(item.name) : null}>
                <div className='insurance_selector_content_left'>
                  {accordion ?
                      <AnchorIcon name={getIconName(item.name)} size="small" stroke={1}/>
                    :
                    <AnchorCheckbox 
                      checked={checked[item.name]}
                      value={item}
                      onToggled={(event) => handleToggle(event)}
                      style={"--p-size-static-150: 0px; --p-size-static-200: 8px"}
                    />
                  }
                  <div className='insurance_selector_info'>
                    <label>{item.label}</label>
                    <span className="insurance_selector_separator">|</span>
                    <div>
                      <span>
                        {checked[item.name] ? Math.round(userData[`totalPrice-${item.name}`]) 
                                            : Math.round(getPrice(item.name))}  
                        {getPrice(item.name) === 0 ? <Text value="$[units.0]"/>
                                                   : <Text value="$[units.$[paymentFrequency]]" />}
                      </span>
                    </div>
                  </div>
                </div>
                <AnchorProductIllustration name={item.icon} size={item.size}></AnchorProductIllustration>
              </div>
              {((expand[item.name] || !accordion) && showAdditionalCoverage) && 
                <CombinedInsuranceAdditional 
                  additionalCoverage={item.additionalCoverage}
                  dispatch={dispatch}
                  userData={userData}
                  insuranceName={item.name}
                  setAddCov={setAddCov}
                  values={values}
                  setValues={setValues}
                  checked={checked}
                />
              }
            </div>
          )
        })}
      </div>
  )
}

CombinedInsuranceSelector.defaultProps = {
  useBasketList: false
}

CombinedInsuranceSelector.propTypes = {
  components: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  initialCheckedState: PropTypes.object.isRequired,
  getExpandState: PropTypes.func.isRequired,
  getPrice: PropTypes.func.isRequired,
  accordion: PropTypes.bool.isRequired,
  showAdditionalCoverage: PropTypes.bool.isRequired,
  useBasketList: PropTypes.bool,
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  basketList: PropTypes.array.isRequired,
};